import React from "react";
import "./footer.css";
import logo from "../../assets/Footer/saif-aviator-white-logo.svg";

export default function Footer() {
  return (
    <footer>
      <div className="footer__wrapper">
        <div className="container">
          <div className="footer-inner">
            <div className="footer-items">
              <div className="footer-logo">
                <img src={logo} alt="agent-sketch-logo" />
              </div>
              <div className="list-name">
                <p>
                  Discover how AI security, risk mitigation, and compliance
                  assurance can protect your AI systems.
                </p>
              </div>
            </div>
            <div className="footer-end">
              <div className="row" style={{ alignItems: "center" }}>
                <div className="col-sm-7 col-md-7 col-lg-7">
                  <div className="footer-links">
                    <p>Legal</p>
                    <p>Privacy Policy</p>
                    <p>Terms & Conditions</p>
                  </div>
                </div>
                <div className="col-sm-5 col-md-5 col-lg-5 copyright">
                  <p>Copyright 2025. All rights reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
